import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import PropertyTypesSection from './components/PropertyTypesSection';
import WhyUsSection from './components/WhyUsSection';
import TestimonialsPreview from './components/TestimonialsPreview';

const HOME_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website`,
      url: import.meta.env.VITE_SITE_URL || 'https://example.com',
      name: 'MyAbode',
      description: 'Premium property listings — search, compare, and book viewings for homes to buy or rent.',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/listings?search={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'RealEstateAgent',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#organization`,
      name: 'MyAbode',
      url: import.meta.env.VITE_SITE_URL || 'https://example.com',
      logo: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/favicon.png`,
      description: 'MyAbode is your trusted real estate platform to search, filter, and compare premium property listings.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '123 Property Lane, Suite 400',
        addressLocality: 'New York',
        addressRegion: 'NY',
        postalCode: '10001',
        addressCountry: 'US',
      },
      telephone: '+18005550000',
      email: 'hello@myabode.com',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '19:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday', 'Sunday'],
          opens: '10:00',
          closes: '17:00',
        },
      ],
      sameAs: [
        'https://www.instagram.com/myabode',
        'https://www.facebook.com/myabode',
        'https://www.linkedin.com/company/myabode',
      ],
    },
  ],
};

const HomePage = () => {
  useEffect(() => {
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(HOME_SCHEMA);
    document.title = 'MyAbode | Premium Property Listings, Search & Book Viewings';
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <PropertyTypesSection />
        <FeaturedSection />
        <WhyUsSection />
        <TestimonialsPreview />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
